import { useState, useEffect, useCallback } from "react";

// Module-level capture — runs once when this module is first imported.
// Ensures the beforeinstallprompt event is never lost, regardless of which route is active.
let capturedEvent = null;
const subscribers = new Set();

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  capturedEvent = e;
  subscribers.forEach((fn) => fn(e));
});

export default function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(capturedEvent);
  const [showInstallPrompt, setShowInstallPrompt] = useState(capturedEvent !== null);

  useEffect(() => {
    const handler = (event) => {
      setDeferredPrompt(event);
      setShowInstallPrompt(true);
    };
    subscribers.add(handler);

    // Sync in case the event arrived between render and effect
    if (capturedEvent && !deferredPrompt) {
      setDeferredPrompt(capturedEvent);
      setShowInstallPrompt(true);
    }

    return () => {
      subscribers.delete(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const installApp = useCallback(() => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setShowInstallPrompt(false);
        setDeferredPrompt(null);
        capturedEvent = null;
      });
    }
  }, [deferredPrompt]);

  const dismissPrompt = useCallback(() => {
    setShowInstallPrompt(false);
  }, []);

  return { showInstallPrompt, installApp, dismissPrompt };
}
